// Feature flags configuration
// These can be overridden by environment variables

// App version from package.json (injected at build time via VITE_APP_VERSION).
// The fallback is intentionally a sentinel — any analytics event reporting
// app_version="0.0.0-unset" means the build pipeline dropped the env var.
// Guard in production builds: loud console error so the CI logs catch it.
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || "0.0.0-unset";
if (import.meta.env.PROD && APP_VERSION === "0.0.0-unset") {
  console.error("[config] VITE_APP_VERSION is unset in a production build — analytics will report app_version=0.0.0-unset");
}

const STAGING_WEB_HOSTS = new Set(["staging.stasht.app"]);
const STAGING_EXECUTE_API_URL = "https://dy9hvwrek2.execute-api.us-east-1.amazonaws.com/staging";

const getBrowserHostname = (): string | undefined => {
  if (typeof window === "undefined") return undefined;
  return window.location.hostname.toLowerCase();
};

const isHostedStagingSurface = (): boolean => {
  const hostname = getBrowserHostname();
  return Boolean(hostname && STAGING_WEB_HOSTS.has(hostname));
};

const HOSTNAME = getBrowserHostname();
const IS_STAGING_HOST = isHostedStagingSurface();
const DEFAULT_API_ENV = import.meta.env.PROD ? "production" : "development";
const API_ENV = IS_STAGING_HOST ? "staging" : import.meta.env.VITE_API_ENV || DEFAULT_API_ENV;
const API_URL = IS_STAGING_HOST ? STAGING_EXECUTE_API_URL : import.meta.env.VITE_API_URL;
const CHAT_STREAM_URL = IS_STAGING_HOST ? undefined : import.meta.env.VITE_CHAT_STREAM_URL;

// Environment variables (raw values)
export const CONFIG = {
  // API Configuration
  API_URL,
  API_KEY: import.meta.env.VITE_API_KEY,
  CHAT_STREAM_URL,

  // Map Configuration
  MAPBOX_ACCESS_TOKEN: import.meta.env.VITE_MAPBOX_ACCESS_TOKEN?.trim(),

  // Social Auth
  GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID,
  GOOGLE_IOS_CLIENT_ID: import.meta.env.VITE_GOOGLE_IOS_CLIENT_ID,
  APPLE_CLIENT_ID: import.meta.env.VITE_APPLE_CLIENT_ID,
  APPLE_REDIRECT_URI: import.meta.env.VITE_APPLE_REDIRECT_URI,

  // Environment flags
  IS_DEVELOPMENT: import.meta.env.DEV,
  IS_PRODUCTION: import.meta.env.PROD,
  API_ENV,
  HOSTNAME,
  IS_STAGING_HOST,

} as const;

export const FEATURES = {
  // Data source flags (dev only)
  USE_MOCK_DATA: import.meta.env.VITE_USE_MOCK_DATA === "true",
  USE_MOCK_AUTH: import.meta.env.VITE_USE_MOCK_AUTH === "true",

  // Authentication
  USE_EMAIL_AUTH: import.meta.env.VITE_USE_EMAIL_AUTH !== "false", // Enabled by default

  // Development
  ENABLE_API_LOGS: import.meta.env.VITE_ENABLE_API_LOGS === "true",

  // Map
  MAP_PUBLIC_MODE: import.meta.env.VITE_MAP_PUBLIC_MODE === "true",

  // Ask Stasht
  ASK_STASHT_STRUCTURED: import.meta.env.VITE_ASK_STASHT_STRUCTURED === "true",
} as const;
